import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetConsentsResponse extends BackendResponse {
  items: ConsentSummary[];
}

export const getAllConsents =
  withNextApi<GetConsentsResponse>(
    "/cvp/CvpGetAllConsents",
    { method: "GET" }
  );
  
export interface ConsentSummary {
  id: number;
  description: string;
  name: string;
}